import { isNil } from "lodash/fp"
import log from "loglevel"
import { inspect } from "./inspect"
import { httpRequest } from "../../functions/common"
import { format } from 'date-fns/fp'
import { v4 } from 'uuid'

log.setLevel(log.levels.DEBUG)

const env = process.env['REACT_APP_ENV'] ?? 'dev'


const baseName = 'miraiz-connect.jp'
const zoneName = `${{ prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
    }${baseName}`
const domainName = `api${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
    }.form-builder.${zoneName}`

export const sendRequestData = async (formData: any): Promise<boolean> => {
    const sendDate = format('yyyy-MM-dd HH:mm:ss')(new Date())
    const result = await httpRequest('POST', `https://${domainName}/v1/form/request`, { projectId: '019ab97f-4df0-7449-afa2-3aaf65efa6cd', data: { id: v4(), sendDate, formData } })
    if (isNil(result) || result.status !== 202) {
        return false
    }
    log.error(`[functions.sendRequestData]`, inspect(result))
    return true
}